import Badge from "components/General/Badge";
import AgentUpdateRelatedDocModal from "components/AgentPortal/ModalDialogs/AgentUpdateRelatedDocModal";
import { v4 as uuidv4 } from "uuid";
import { useState } from "react";
import { odsClaimStatusConversion } from "js/formatting";
import { useTranslation } from "react-i18next";

const ClaimCard = ({ data, cardExpanded }) => {
  const claimId = uuidv4();
  const [isOpen, setIsOpen] = useState(cardExpanded);
  const [isOpenUpdateDoc, setIsOpenUpdateDoc] = useState(false);

  const [statusClass, statusText] = odsClaimStatusConversion(
    data.claimStatus,
    data.claimType
  );
  const { t } = useTranslation();

  return (
    <>
      <div className="ui-card my-4">
        <div className="p-4 xl:px-6">
          <div className="flex flex-col md:flex-row md:justify-between">
            <div className="text-left">
              <button
                id={claimId}
                className="flex items-center group"
                aria-controls={claimId + "-panel"}
                aria-expanded={isOpen}
                aria-label="Expand or collapse claim details"
                onClick={() => setIsOpen((isOpen) => (isOpen = !isOpen))}
              >
                <span className="inline-block p-1 rounded-full mr-1 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                  <svg
                    className="ui-icon ui-plus w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-plus"></use>
                  </svg>
                  <svg
                    className="ui-icon ui-minus w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-minus"></use>
                  </svg>
                </span>
                {data.badgeStatus && (
                  <span className="mr-1 flex items-center md:hidden">
                    <Badge
                      iconOnly={true}
                      status={statusClass}
                      statusText={statusText}
                      srPrefix="Claim"
                    />
                  </span>
                )}
                <span className="text-lg font-semibold text">
                  {t("AgentClaimCard-id")} {data.id}
                </span>
              </button>
            </div>
            {data.badgeStatus && (
              <div className="hidden md:block">
                <Badge
                  status={statusClass}
                  statusText={statusText}
                  srPrefix="Claim"
                />
              </div>
            )}
          </div>
        </div>
        <hr className="ui-collapse" />
        <div className="p-4 xl:px-6">
          <div className="text-xs text-theme-text-tertiary">
            {t("AgentClaimCard-contractnumber")} {data.oldPolicy}
          </div>
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4 xl:gap-6">
            <div>
              <div className="text-xs text-theme-text-tertiary">
                {t("AgentClaimCard-ownername")}
              </div>
              <div className="text-sm font-semibold text-theme-text-secondary">
                {data.owner}
              </div>
            </div>
            <div>
              <div className="text-xs text-theme-text-tertiary">
                {t("AgentClaimCard-contractnumber")}
              </div>
              <div className="text-sm font-semibold text-theme-text-secondary">
                {data.oldPolicy}
              </div>
            </div>
            <div>
              <div className="text-xs text-theme-text-tertiary">
                {t("AgentClaimCard-claimtype")}
              </div>
              <div className="text-sm font-semibold text-theme-text-secondary">
                {data.type}
              </div>
            </div>
          </div>
        </div>
        <div id={claimId + "-panel"} className="px-4 pb-4 xl:px-6 xl:pb-6">
          {isOpen && (
            <div>
              <hr />
            </div>
          )}
        </div>
      </div>
      {/* Update document Dialog */}
      <AgentUpdateRelatedDocModal
        isOpenUpdateDoc={isOpenUpdateDoc}
        setIsOpenUpdateDoc={setIsOpenUpdateDoc}
      />
    </>
  );
};
export default ClaimCard;
